import { createContext, useState } from 'react';

const EditConversationViewContext = createContext<
  | {
      open: boolean;
      setOpen: (open: boolean) => void;
    }
  | undefined
>(undefined);

const EditConversationViewContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <EditConversationViewContext.Provider
      value={{
        open,
        setOpen,
      }}
    >
      {children}
    </EditConversationViewContext.Provider>
  );
};

export { EditConversationViewContext, EditConversationViewContextProvider };
